<template>
  <div>
    <div class="datepicker-device-overview" v-if="this.dev_id">
      <div class="datepicker-trigger">
        <button class="arrow mdi mdi-arrow-left" @click="subDay" :disabled="timer_stats"/>

        <section class="datepicker_input overview_datepicker ">
          <date-picker
            v-model="date"
            type="date"
            format="DD-MM-YYYY"
            valueType="timestamp"
            :clearable="false"
            :disabled-date="disabledDate"
            :disabled="timer_stats"
          />
          <sis-select
            v-if="check_today"
            v-model="period"
            :options="opt_periods"
            :placeholder="translate('period')"
            :clearable="false"
            class="period"
            :disabled="timer_stats"
          />
        </section>

        <button v-if="!show_ref" class="arrow mdi mdi-arrow-right" @click="addDay" :disabled="timer_stats"/>
        <button v-else class="refresh mdi mdi-refresh" @click="refresh" :disabled="timer_stats"/>
      </div>
    </div>
    <div class="charts" v-if="!no_data">
      <div class="chart">
        <SimcardStatusChart
          :main_data="simcard_status"
          :dev_id="dev_id"
          :show_content="show.simcard_status"
          :today="check_today"
        />
      </div>

      <div class="chart">
        <RssiChart
          :main_data="rssi"
          :show_content="show.rssi"
          :hide_block="hide.rssi"
          @hide_rssi="hide_rssi"
          :today="check_today"
        />
      </div>

      <div class="chart">
        <SpeedChart
          :main_data="device_sp"
          :show_content="show.speed"
          :hide_block="hide.speed"
          @hide_speed="hide_speed"
          :today="check_today"
        />
      </div>

      <div class="chart">
        <TemperChart
          :main_data="temper"
          :show_content="show.temper"
          :hide_block="hide.temper"
          @hide_temper="hide_temper"
          :today="check_today"
        />
      </div>

      <div class="chart">
          <CPUChart
            :main_data="cpu"
            :show_content="show.cpu"
            :hide_block="hide.cpu"
            @hide_cpu="hide_cpu"
            :today="check_today"
          />
      </div>
    </div>
    <div v-else style="text-align: center;  vertical-align: middle;">
      <div style="height: 100%">
        <div class="spinner" v-if="timer_stats">
          <scale-loader />
        </div>
        <h1 v-if="!timer_stats && no_data">
          {{translate('no_data')}}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'components/UIComponents/Datepicker2/index.js';

import SimcardStatusChart from 'components/UIComponents/Charts/SimcardStatusChart.vue'
import RssiChart from 'components/UIComponents/Charts/RssiChart.vue'
import SpeedChart from 'components/UIComponents/Charts/SpeedChart.vue'
import TemperChart from 'components/UIComponents/Charts/TemperChart'
import CPUChart from 'components/UIComponents/Charts/CPUChart'

export default {
  name: 'Overview',
  components: {
    DatePicker,
    SimcardStatusChart,
    RssiChart,
    SpeedChart,
    TemperChart,
    CPUChart
  },
  props: ['dev_id', 'profile'],
  data () {
    return {
      device: {},
      temper: {},
      cpu: {},
      simcard_status: {},
      device_sp: {},
      rssi: {},
      date: +(new Date()),
      format_date: '',
      timer_status: null,
      timer_stats: true,
      show_ref: true,
      timer: null,
      period: 1800,
      show: {
        speed: false,
        rssi: false,
        temper: false,
        cpu: false,
        simcard_status: false
      },
      hide:{
        speed: false,
        rssi: false,
        temper: false,
        cpu: false,
        period: '',
        date: ''
      }    }
  },
  computed: {
    no_data(){
      return !((this.simcard_status.data && this.simcard_status.data.length > 0) ||
          (this.rssi.data && this.rssi.data.length > 0) ||
          (this.device_sp.time && this.device_sp.time.length > 0) ||
          (this.temper.time && this.temper.time.length > 0) ||
          (this.cpu.time && this.cpu.time.length > 0));

    },
    opt_periods () {
      return [
        { id: 1800, label: this.translate('30min') },
        { id: 7200, label: this.translate('2hour') },
        { id: 28800 , label: this.translate('8hour') },
        { id: 86400 , label: this.translate('24hour') },
      ]
    },
    check_today(){
      let date = new Date().setHours(0, 0, 0, 0)
      //Можно ли показывать период. -1000 для погрешности милисекунд.
      return (this.date - (+date)) > -1000
    },
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    }
  },
  watch: {
    hide: {
      deep: true,
      handler(){
        let string = '?'

        for (let key in this.hide) {
          string += '&' + key + '=' + this.hide[key]
        }

        history.pushState(null, null, this.$route.path + string)

      }
    },
    simcard_status(){
      setTimeout( () => { this.change_stat_time() }, 1000 )
    },
    dev_id () {
      this.getData()
    },

    date () {
      this.change_stat_time()

      let date = new Date(this.date).setHours(0, 0, 0, 0)
      date = Math.round(date / 1000)

      let today = new Date()
      today = Math.round(new Date(today.getFullYear(), today.getMonth(), today.getDate()) / 1000)

      if (date === today) {
        date = ""
        this.show_ref = true
      } else {
        this.show_ref = false
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout( () => { this.getData(date) }, 1000 )
    },

    period () {

      this.hide.period = this.period

      this.timer_stats = true

      clearTimeout(this.timeout)
      this.timeout = setTimeout( () => { this.getData() }, 1000 )
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer_status)
  },
  created () {
    this.check_query()
  },
  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){

        this.timer_stats = false

        this.hide.rssi = this.$route.query.rssi ? JSON.parse(this.$route.query.rssi) : false
        this.hide.speed = this.$route.query.speed ? JSON.parse(this.$route.query.speed) : false
        this.hide.temper = this.$route.query.temper ? JSON.parse(this.$route.query.temper) : false
        this.hide.cpu = this.$route.query.cpu ? JSON.parse(this.$route.query.cpu) : false

        this.date = this.$route.query.date ? +new Date(+this.$route.query.date*1000) : new Date().setHours(0, 0, 0, 0)

        this.period = this.$route.query.period ? +this.$route.query.period : 1800

      }else{
        this.getData()
      }
    },
    change_stat_time(){
      this.timer_stats = !this.timer_stats
    },
    disabledDate(date) {
      let today = new Date();
      return date > new Date(today.getTime()) || date < new Date(today.getTime() - this.datetime_picker * 24 * 3600 * 1000);
    },

    async getData (date) {
      if (this.$route.name === 'device_section') {
        let set_date = {}

        if (date){
          set_date = {time_start: date}
          this.hide.date = date
          this.hide.period = 1800
        }else{
          set_date = {period: this.period}

          this.hide.date = Math.round(+new Date(new Date().setHours(0, 0, 0, 0)) / 1000)
          this.hide.period = +this.period
        }

        this.show.simcard_status = false
        this.show.rssi = false

        await this.$http.v1.getDeviceTimeline(this.dev_id, set_date, (response) => {
          this.simcard_status = response.data.timeline
          this.rssi = response.data.rssi
          this.show.simcard_status = true
          this.show.rssi = true

        })

        this.show.speed = false

        this.$http.v1.getDeviceSpeed(this.dev_id, set_date, (response) => {
          this.device_sp = response.data
          this.show.speed = true
        })

        this.show.temper = false

        this.$http.v1.getDeviceTemper(this.dev_id, set_date, (response) => {
          this.temper = response.data
          this.show.temper = true
        })

        this.show.cpu = false

        this.$http.v1.getDeviceCPU(this.dev_id, set_date, (response) => {
            this.cpu = response.data
            this.show.cpu = true
        })
      }
    },
    hide_rssi(){
      this.hide.rssi = !this.hide.rssi
    },
    hide_speed(){
      this.hide.speed = !this.hide.speed
    },
    hide_temper(){
      this.hide.temper = !this.hide.temper
    },
    hide_cpu(){
        this.hide.cpu = !this.hide.cpu
    },
    addDay() {
      let date = new Date(this.date)
      date.setDate(date.getDate() + 1);
      this.date = +date
    },

    subDay() {
      let date = new Date(this.date)
      date.setDate(date.getDate() - 1);
      this.date = +date
    },
    refresh () {
      this.change_stat_time()
      this.getData()
    },
  }
}

</script>
<style lang="scss">

  .datepicker_input {
    .mx-input {
      display: inline-block;
      border: 1px solid #CCC5B9;
      border-radius: 4px;
      text-align: center;
      min-width: 210px;
      background-color: #ffffff;
      font-size: 16px;
      max-width: 300px;
      height: 45px;
      width: 80%;
    }

    input[readonly] {
      cursor: pointer;
      color: #000000;
      background-color: #FFFFFF;
    }
  }

  .datepicker-trigger {
    padding-top: 15px;
    text-align: center;
    display: inline-flex;
    width: 100%;
    justify-content: center;
  }

  .datepicker-device-overview {
    text-align: center;
  }

  .arrow {
    width: 45px;
    display: inline-block;
    border:  1px solid #CCC5B9;
    border-radius: 4px;
    padding: 5px 10px;
    height: 45px;
    font-size: 26px;
    background-color: #FFFFFF;
  }

  .refresh {
    width: 45px;
    display: inline-block;
    border:  1px solid #CCC5B9;
    border-radius: 4px;
    height: 45px;
    background-color: #FFFFFF;
    font-size: 2em;
  }

  .device-overview-datepicker-input {
    flex-grow: 1;
  }
  .refresh:hover,
  .arrow:hover {
    background-color: rgba(219, 228, 230, 0.3);
  }
  .overview_datepicker {
    display: flex;
    .mx-icon-clear{
      display: none;
    };
    .period{
      height: 45px;
      max-width: 150px;
      margin-bottom: 0;
      .vue-treeselect__control{
        height: 45px;
        background-color: white;
        border: 1px solid #CCC5B9;
        .vue-treeselect__single-value{
          line-height: 44px;
          font-size: 16px;
        }
      }
    }
  }

  .charts{
    padding: 20px 0 10px;
    .chart{
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }

  .overview {
    > *:not(:first-child) {
      margin-top: 7px;
    }
  }

  @media (max-width:550px){
    .overview_datepicker {
      flex-direction: column;
      .period{
        min-width: 210px;
      }
    }
  }

</style>
